
import {
    ADD_VIDEO, UPDATE_LIST, GET_INFO, GET_CHANNEL_INFO, ADD_USER,
    GET_LISTS_INFO, GET_ONE_LIST,
} from "./constants";
import {
    getInfoApi, getChannelInfoApi, getListsInfoApi,
    getListVideoById,
} from "./controllers/controllers";




export const addUser = (user: object | null) => (
    { type: ADD_USER, payload: user }
);

export const addVideo = (video: object) => (
    { type: ADD_VIDEO, payload: video }
);

export const updateList = (video: object[]) => (    
    { type: UPDATE_LIST, payload: video }
);

export const getInfo = (search: string): any => async (dispatch: any): Promise<any> => {

    try {

        const infoApi = await getInfoApi(search);

        dispatch({
            type: GET_INFO,
            payload: infoApi
        });

    } catch (error) {
        console.log(error, 'error al llama a la api');
    }
}


export const getChannel = (channelId: string | undefined): any => async (dispatch: any): Promise<any> => {

    try {

        const channelInfoApi = await getChannelInfoApi(channelId);

        dispatch({
            type: GET_CHANNEL_INFO,
            payload: channelInfoApi
        });

    } catch (error) {
        console.log(error, 'error al llama a la api');
    }
}

export const getAllLists = (): any => async (dispatch: any): Promise<any> => {

    try {

        const listsInfoApi = await getListsInfoApi();

        dispatch({
            type: GET_LISTS_INFO,
            payload: listsInfoApi
        });

    } catch (error) {
        console.log(error, 'error al llama a la api');
    }
}

export const getOneListsById = (listId: string | undefined): any => async (dispatch: any): Promise<any> => {

    try {

        const onelistVideo = await getListVideoById(listId);

        dispatch({
            type: GET_ONE_LIST,
            payload: onelistVideo
        });

    } catch (error) {
        console.log(error, 'error al llama a la api');
    }
}